import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const Fieldset = (props) => {
    const intl = useIntl();
    return (
        <div className={['govuk-form-group', (props.errorMessage ? 'govuk-form-group--error' : null)].join(' ')}>
            <fieldset className="govuk-fieldset" role="group">
                <legend { ...props.labelProps } className={['govuk-fieldset__legend', (props.labelAsTitle ? 'govuk-fieldset__legend--l' : null)].join(' ')} data-testid={props['data-testid'] ? props['data-testid'] + '-label' : null}>
                    {props.label}
                </legend>
                {props.description && <div { ...props.descriptionProps } className='govuk-hint' data-testid={ props['data-testid'] ? props['data-testid'] + '-hint' : null }>
                    {props.description}
                </div>}
                {
                    props.errorMessage &&
                    <p { ...props.errorMessageProps } className="govuk-error-message" data-testid={ props['data-testid'] ? props['data-testid'] + '-error' : null }>
                        <span className="govuk-visually-hidden">{intl.formatMessage({ id: 'errorLabel' })}:</span> { props.errorMessage }
                    </p>
                }
                {props.children}
            </fieldset>
        </div>
    );
};

Fieldset.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    description: PropTypes.string,
    errorMessage: PropTypes.string,
    children: PropTypes.element,
    'data-testid': PropTypes.string,
    labelProps: PropTypes.object,
    descriptionProps: PropTypes.object,
    errorMessageProps: PropTypes.object
};

Fieldset.defaultValue = {
    labelAsTitle: false
};

export default Fieldset;
